// Native replacement for the "Accident form" Google Form (accidents and medication). Manager only.

import React from "react";
import { MenuItem, TextField } from "@mui/material";
import {
  ACCIDENT_CATEGORIES,
  OLD_FORM_URLS,
  TEACHER_IDS,
  submitAccident,
  todayYmd,
  validateAccident,
  type AccidentInput,
} from "../../shared/nativeForms";
import { DateField, FormShell, SelectField, TextAreaField, childLabel, useAllowed, useChildOptions, useNativeForm } from "./FormParts";

const empty = (): AccidentInput => ({
  childId: "", teacherId: "", category: "", details: "", location: "", followUpSteps: "", date: todayYmd(),
});

const AccidentFormPage: React.FC = () => {
  const allowed = useAllowed("manager");
  const children = useChildOptions();
  const form = useNativeForm<AccidentInput>(empty, (values) => validateAccident(values, null), submitAccident);
  const { values, errors, set } = form;

  return (
    <FormShell
      title="New accident or medication"
      allowed={allowed}
      deniedText="Accident and medication reports can be added by the manager only (info@bee-happy.club)."
      oldFormUrl={OLD_FORM_URLS.accident}
      form={form}
      savedText="Report saved. It shows in the lists the next time the portal loads."
      addAnotherLabel="Add another report"
    >
      <TextField select fullWidth required label="Child" value={values.childId} error={!!errors.childId} helperText={errors.childId}
        onChange={(event) => set("childId", event.target.value)}>
        {children.map((child) => <MenuItem key={child.id} value={child.id}>{childLabel(child)}</MenuItem>)}
      </TextField>
      <SelectField label="Teacher" value={values.teacherId} options={TEACHER_IDS} onChange={(v) => set("teacherId", v)} error={errors.teacherId} />
      <SelectField label="Category" value={values.category} options={ACCIDENT_CATEGORIES} onChange={(v) => set("category", v)} error={errors.category} />
      <TextAreaField label="Details" rows={4} value={values.details} onChange={(v) => set("details", v)} error={errors.details} />
      <TextAreaField label="Location" value={values.location} onChange={(v) => set("location", v)} error={errors.location} />
      <TextAreaField label="Follow-up steps" value={values.followUpSteps} onChange={(v) => set("followUpSteps", v)} error={errors.followUpSteps} />
      <DateField label="Date" value={values.date} onChange={(v) => set("date", v)} error={errors.date} />
    </FormShell>
  );
};

export default AccidentFormPage;
